export default __webpack_public_path__ + "static/media/bg.92ec8faa.webp";